"use client";
import Link from "next/link";
import React from "react";

export default function PageHeading({ title, link }) {
  return (
    <div className="page-heading">
      <h1>{title}</h1>
      <div className="two-button-head">
        <Link href={link} className="cta-btn">
          Register a Product
        </Link>
        <Link href={"/serial-search"} className="cta-btn">
          Serial Search
        </Link>
      </div>
    </div>
  );
}
